'use client'

import {
  createContext,
  type FC,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react'

interface NewsletterSubscribeContextType {
  email: string
  isSubscribed: boolean
  setEmail: (email: string) => void
  setIsSubscribed: (isSubscribed: boolean) => void
}

const noop = (): void => {
  throw new Error(
    '[NewsletterSubscribeContext] Please use inside of <NewsletterSubscribeProvider> !',
  )
}

const defaultValue: NewsletterSubscribeContextType = {
  email: '',
  isSubscribed: false,
  setEmail: noop,
  setIsSubscribed: noop,
}

const NewsletterSubscribeContext =
  createContext<NewsletterSubscribeContextType>(defaultValue)

interface NewsletterSubscribeProviderProps {
  children: ReactNode
}

export const NewsletterSubscribeProvider: FC<
  NewsletterSubscribeProviderProps
> = ({ children }) => {
  const [email, setEmail] = useState<string>('')
  const [isSubscribed, setIsSubscribed] = useState<boolean>(false)

  const value = useMemo(
    () => ({
      email,
      isSubscribed,
      setEmail,
      setIsSubscribed,
    }),
    [email, isSubscribed],
  )

  return (
    <NewsletterSubscribeContext.Provider value={value}>
      {children}
    </NewsletterSubscribeContext.Provider>
  )
}

export const useNewsletterSubscribeContext =
  (): NewsletterSubscribeContextType => {
    return useContext(NewsletterSubscribeContext)
  }
